"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection336sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-3 col-lg-3 col-md-6" | "col-lg-2 col-md-6" | "col-lg-4 col-md-6" */
    className: string;
    /** Detected variants: "footer-widget footer-about" | "footer-widget divide-line" | "footer-widget footer-contact divide-line" | "footer-widget" */
    div0ClassName: string;
    /** Detected variants: "footer-about-content" | "contact-info mb-0" */
    div1ClassName?: string;
    /** Detected variants: "8432 Mante Highway, Aminaport, USA" */
    p0Text?: ReactNode;
    /** Detected variants: "Our Address" */
    span0Text?: ReactNode;
    /** Detected variants: "title" */
    span0ClassName?: string;
    /** Detected variants: "Company" | "Contact" | "Subscribe Newsletter's" */
    h50Text?: ReactNode;
    /** Detected variants: "footer-title" */
    h50ClassName?: string;
    contactInfoItems?: FooterSection1sItem[];
    socialIconItems?: FooterSectionUlsItem[];
    footerMenuItems?: FooterSectionUls2Item[];
};

type FooterSection1sItem = {
    key: Key | null | undefined;
    /** Detected variants: "mb-1" */
    className?: string;
    /** Detected variants: "+1 54565 64578" | "info@example.com" */
    link0Text: ReactNode;
    /** Detected variants: "tel:5456564578" | "mailto:info@example.com" */
    href: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Clinics" | "Hospitals" | "Specialities" | "Contact Us" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.clinics" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.contactUs" */
    href: string;
};

type FooterSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Modern ENT Center" | "Better Everyday Health" | "Advanced ENT Care" */
    h20Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
};
export type HomeFiveFooterSectionGeneratedProps = {
    divDiv0H50H5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection336sItem) => Partial<ComponentProps<"h5">>);
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "left" */
    footerDiv1DivDataDirection?: string;
    /** Default: "slow" */
    footerDiv1DivDataSpeed?: string;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv2Div0Div0Div0P0PText?: ReactNode;
    /** Default: "star-icon" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/star-icon.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "star-icon" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/star-icon.png" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    pLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSection1sItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection336s: FooterSection336sItem[];
    footerSectionServicesSlides: FooterSectionServicesSlidesItem[];
    footerSection336sItemWrapper?: (item: FooterSection336sItem, content: ReactNode) => ReactNode;
    footerSection336sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection336sH5Visible?: boolean;
    footerSection336sH5Renderer?: (item: FooterSection336sItem, defaultNode: ReactNode) => ReactNode;
    footerSection336sH5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection336sItem) => Partial<ComponentProps<"h5">>);
    footerSection1sItemWrapper?: (item: FooterSection1sItem, content: ReactNode) => ReactNode;
    footerSection1sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection1sLinkVisible?: boolean;
    footerSection1sLinkRenderer?: (item: FooterSection1sItem, defaultNode: ReactNode) => ReactNode;
    footerSection1sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSection1sItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls2ItemWrapper?: (item: FooterSectionUls2Item, content: ReactNode) => ReactNode;
    footerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesItemWrapper?: (item: FooterSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    footerSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesH2Visible?: boolean;
    footerSectionServicesSlidesH2Renderer?: (item: FooterSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesH2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
};

const HomeFiveFooterSectionGenerated: FC<HomeFiveFooterSectionGeneratedProps> = ({
    footerDiv1DivDataDirection = "left",
    footerDiv1DivDataSpeed = "slow",
    footerDiv2Div0Div0Div0P0PText = "Copyright © 2026 Doccure. All Rights Reserved",
    footerImageWithBasePath0ImageAlt = "star-icon",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/star-icon.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "star-icon",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/star-icon.png",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    divDiv0H50H5Props,
    divH20H2Props,
    pLink0LinkProps,
    footerDiv0Div0Div0ClassName,
    footerSection336s,
    footerSectionServicesSlides,
    footerSection336sItemWrapper,
    footerSection336sRenderer,
    footerSection336sH5Visible,
    footerSection336sH5Renderer,
    footerSection336sH5Props,
    footerSection1sItemWrapper,
    footerSection1sRenderer,
    footerSection1sLinkVisible,
    footerSection1sLinkRenderer,
    footerSection1sLinkProps,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUls2ItemWrapper,
    footerSectionUls2Renderer,
    footerSectionServicesSlidesItemWrapper,
    footerSectionServicesSlidesRenderer,
    footerSectionServicesSlidesH2Visible,
    footerSectionServicesSlidesH2Renderer,
    footerSectionServicesSlidesH2Props,
}) => {
    return (
        <footer className="footer-five">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-4"}>
                        {renderCollectionNode(
                            footerSection336s,
                            (item: FooterSection336sItem) => (
                                <div className={item.className} key={item.key}>
                                    <div className={item.div0ClassName}>
                                        {renderItemNode(footerSection336sH5Visible, footerSection336sH5Renderer, item, (
                                            <h5 className={item.h50ClassName} {...(typeof footerSection336sH5Props === "function" ? footerSection336sH5Props(item) : (footerSection336sH5Props ?? {}))} {...(typeof divDiv0H50H5Props === "function" ? divDiv0H50H5Props(item) : (divDiv0H50H5Props ?? {}))}>{item.h50Text}</h5>
                                        ))}
                                        <div className="contact-info">
                                            <span className="title">Call / E-mail</span>
                                            {renderCollectionNode(
                                                item.contactInfoItems ?? [],
                                                (item: FooterSection1sItem) => (
                                                    <p className={item.className} key={item.key}>
                                                        {renderItemNode(footerSection1sLinkVisible, footerSection1sLinkRenderer, item, (
                                                            <SmartLink href={item.href} {...(typeof footerSection1sLinkProps === "function" ? footerSection1sLinkProps(item) : (footerSection1sLinkProps ?? {}))} {...(typeof pLink0LinkProps === "function" ? pLink0LinkProps(item) : (pLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                        ))}
                                                    </p>
                                                ),
                                                footerSection1sItemWrapper,
                                                footerSection1sRenderer
                                            )}
                                        </div>
                                        <div className={item.div1ClassName}>
                                            <span className={item.span0ClassName}>{item.span0Text}</span>
                                            <p>{item.p0Text}</p>
                                        </div>
                                    </div>
                                </div>
                            ),
                            footerSection336sItemWrapper,
                            footerSection336sRenderer
                        )}
                    </div>
                </div>
            </div>
            <div className="horizontal-slide slide-five d-flex" data-direction={footerDiv1DivDataDirection} data-speed={footerDiv1DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        footerSectionServicesSlides,
                        (item: FooterSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(footerSectionServicesSlidesH2Visible, footerSectionServicesSlidesH2Renderer, item, (
                                    <h2 {...(typeof footerSectionServicesSlidesH2Props === "function" ? footerSectionServicesSlidesH2Props(item) : (footerSectionServicesSlidesH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>{item.h20Text}</h2>
                                ))}
                            </div>
                        ),
                        footerSectionServicesSlidesItemWrapper,
                        footerSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright text-center">
                        <div className="copyright-text">
                            <p className="mb-0">{footerDiv2Div0Div0Div0P0PText}</p>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="img-fluid element-1 star-5" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="img-fluid element-2 star-5" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
        </footer>
    );
};

export default HomeFiveFooterSectionGenerated;
